import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Right-aligned area for primary actions. */
  actions?: ReactNode;
  /** Optional count chip (e.g. result count). Mirrors pa-jp ListPageHeader. */
  count?: number | string;
  className?: string;
}

export const PageHeader = ({ title, subtitle, actions, count, className }: PageHeaderProps) => {
  return (
    <header
      className={cn(
        'flex flex-col items-start justify-between gap-3 border-b border-efs-border pb-4 sm:flex-row sm:items-start sm:gap-4',
        className,
      )}
    >
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-semibold tracking-tight text-efs-text-primary">{title}</h1>
          {count !== undefined ? (
            <span className="inline-flex items-center rounded-md bg-efs-bg-subtle px-2 py-0.5 text-xs font-medium text-efs-text-muted">
              {count}
            </span>
          ) : null}
        </div>
        {subtitle ? <p className="mt-1 text-sm text-efs-text-muted">{subtitle}</p> : null}
      </div>
      {actions ? (
        <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto sm:shrink-0">
          {actions}
        </div>
      ) : null}
    </header>
  );
};
